import { useEffect, useState, useRef } from "react"
import { useGetBodypartsQuery, useUpdateBodypartMutation, useAddNewBodypartMutation } from "./bodypartsApiSlice"
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { toast } from 'react-toastify'
import useAuth from '../../hooks/useAuth'
import Bodypart from './Bodypart'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave } from "@fortawesome/free-solid-svg-icons"


const BodypartsList = () => {

	useTitle('DPE: Bodyparts')

	const { isAdmin } = useAuth()

	const closeRef = useRef();

	// state for Bodypart info
	const [currentBodypartId, setcurrentBodypartId] = useState('')
	const [currentBodypart, setcurrentBodypart] = useState('')

	const onBodypartChanged = e => setcurrentBodypart(e.target.value)
	const onBodypartIdChanged = e => setcurrentBodypartId(e.target.value)

	const handleBodypartChange = (id, part) => {
		setcurrentBodypart(part)
		setcurrentBodypartId(id)
	};

	// pagination: 1
	const [currentPage, setcurrentPage] = useState(1)
	const [itemsPerPage, setitemsPerPage] = useState(3)
    const updateitemsPerPage = (e) => {
        setitemsPerPage(e.target.value)
        setcurrentPage(1)
    }
	const pageSizes = [3, 6, 9, 12, 15];



	// load body parts
	const {
		data: bodyparts,
		isLoading,
		isSuccess,
		isError,
		error
	} = useGetBodypartsQuery('bodypartsList')

	useEffect(() => {

		if (isError) {
			toast.error(error?.data?.message);
		}

	}, [isError, error])


	// update Bodypart
	const [updateBodypart, {
		isSuccess: isUpdateSuccess,
		isError: isUpdateError,
		error: errorUpdate
	}] = useUpdateBodypartMutation()

	useEffect(() => {

		if (isUpdateSuccess) {
			setcurrentBodypartId('')
			setcurrentBodypart('')
			closeRef.current.click()
			toast.success("Bodypart was Updated");
		}

		if (isUpdateError) {
			toast.error(errorUpdate?.data?.message);
		}

	}, [isUpdateSuccess, isUpdateError, errorUpdate])

	// add Bodypart
	const [addBodypart, {
		isSuccess: isAddSuccess,
		isError: isAddError,
		error: errorAdd
	}] = useAddNewBodypartMutation()

	useEffect(() => {
		if (isAddSuccess) {
			setcurrentBodypartId('')
			setcurrentBodypart('')
			closeRef.current.click()
			toast.success("Bodypart was Added");
		}
		if (isAddError) {
			toast.error(errorAdd?.data?.message);
		}
	}, [isAddSuccess, isAddError, errorAdd])


	const onSaveBodypartClicked = async (e) => {
		if (currentBodypartId === '') {
			await addBodypart({ bodypart: currentBodypart })
		} else {
			await updateBodypart({ id: currentBodypartId, bodypart: currentBodypart })
		}
	}





	let content

	if (isLoading) content = <PulseLoader color={"#5f788a"} />

	if (isSuccess) {

		if (!isAdmin) {
			return toast.error('Not Authorized');
		}

		const { ids } = bodyparts

		// pagination: 2
		const totalItems = ids.length
		const lastIndex = currentPage * itemsPerPage
		const firstIndex = lastIndex - itemsPerPage
		const currentPageItems = ids.slice(firstIndex, lastIndex)
		let lastPage = Math.ceil(ids.length / itemsPerPage)
		const pages = []
        if (totalItems <= itemsPerPage) {
            let i=1
            pages.push(i)
            lastPage=1
        } else {
            for (let i=1 ; i < lastPage+1 ; i++){                
                pages.push(i)
            }
        }

		let tableContent = null
		tableContent = currentPageItems.map(bodypartId => <Bodypart key={bodypartId} bodypartId={bodypartId} onBodypartChange={handleBodypartChange} />)

		content = (
			<section id="main_content">

				<div className="modal" id="modalBodypart">
					<div className="modal-dialog">
						<div className="modal-content">

							<div className="modal-header">
								<h4 className="modal-title">Edit Bodypart</h4>
								<button type="button" className="btn-close" data-bs-dismiss="modal" ref={closeRef}></button>
							</div>

							<div className="modal-body text-end bg-secondary bg-opacity-25">
								<form onSubmit={e => e.preventDefault()}>
									<input id="bodypart" className="form-control" value={currentBodypart} onChange={onBodypartChanged} />
									<input id="bodypart_id" type="hidden" value={currentBodypartId} onChange={onBodypartIdChanged} />
									<br />
									<span
										role="button"
										className="text-success p-2 icon"
										title="Save"
										onClick={onSaveBodypartClicked}
									>
										Save Bodypart
										<FontAwesomeIcon icon={faSave}  className="fa-icon"/>
									</span>
								</form>
							</div>
						</div>
					</div>
				</div>

				<header>
					<div className="row">
						<div className="col-md-4">
							<h1 className="text-steel mt-5">Bodyparts</h1>
						</div>
						<div className="col-md-2 text-end mt-3">
							{totalItems} total items
						</div>
					</div>
				</header>
				<main>
					<div className="row">
						<div className="col-md-6">
							<table className="table table-striped">
								<thead>
									<tr>
										<th>Bodypart</th>
										<th>Edit</th>
									</tr>
								</thead>
								<tbody>
									{tableContent}
								</tbody>
							</table>
						</div>
					</div>

					<div className="row">
						<div className="col-md-2">
							<ul className="pagination">
								{
									pages.map((page, index) => {
										let clsName = currentPage - 1 === index ? 'page-item active' : "page-item"
										return (
											<li key={index} className={clsName}>
												<span className="page-link" role="button" onClick={() => setcurrentPage(page)}>{page}</span>
											</li>
										)
									})
								}
							</ul>


						</div>
						<div className="col-md-3 text-end mt-2">
							<label  style={{marginRight:"10px"}}>Items per page</label>
						</div>
						<div className="col-md-1">
							<select name="itemsPerPage" id="itemsPerPage" className="form-control  text-end"
								value={itemsPerPage}
                                onChange={updateitemsPerPage}>
								{pageSizes.map((option, index) => {
									return (
										<option key={index}>
											{option}
										</option>
									);
								})}
							</select>
						</div>
					</div>


					<div className="row">
						<div className="col-md-6 text-end">
							<button className="btn btn-steel" data-bs-toggle="modal" data-bs-target="#modalBodypart">
								Add Bodypart
							</button>
						</div>
					</div>
				</main>
			</section>

		)

	}

	return content

}
export default BodypartsList